

  <!-- 
  <PageSize :currentPage='currentPage' :total='total' :pageSizes='pageSizes' :pageSize='pageSize' :page="'page'" :size="'size'" />
  currentPage:默认第一页
  total：总条数
  pageSizes：每页可以选择的展示多少条  [10, 20, 50, 100, 200]
  pageSize：默认第一页展示10条
  page：自己定义的第几页字段
  size: 自己定义的一页多少条的字段
   -->
  <template>
  <div>
    <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPageL" :page-sizes="pageSizesL" :page-size="pageSizeL" layout="total, sizes, prev, pager, next, jumper" :total="totalL">
    </el-pagination>
  </div>
</template>

<script>
export default {
  name: "HelloWorld",
  props: {
    currentPage: Number,
    total: Number,
    pageSizes: Array,
    pageSize: Number,
    page: String,
    size: String
  },
  data() {
    return {
      currentPageL: this.currentPage, //默认第一页
      totalL: this.total, //总条数
      pageSizesL: this.pageSizes, //每页展示多少条
      pageSizeL: this.pageSize //默认第一页展示10条
    };
  },
  mounted() {},
  methods: {
    handleSizeChange(val) {
      let path = this.$route.fullPath;
      let query = this.$route.query;
      console.log(this.page);
      let size = {};
      size[this.size] = val;
      let newQuery = this.$Method.NewQuery(query, size);
      this.$router.push({ path: path, query: newQuery });
    },
    handleCurrentChange(val) {
      let path = this.$route.fullPath;
      let query = this.$route.query;
      let size = {};
      size[this.page] = val;
      let newQuery = this.$Method.NewQuery(query, size);
      this.$router.push({ path: path, query: newQuery });
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #cc4455;
}
.el-select-dropdown__item.selected {
  color: #cc4455;
  font-weight: 700;
}
.el-select .el-input.is-focus .el-input__inner {
  border-color: #cc4455;
}
.el-pagination__sizes .el-input .el-input__inner:hover {
  border-color: #cc4455;
}
.el-input__inner:focus {
  border-color: #cc4455;
  outline: 0;
}
.el-pagination.is-background .el-pager li:not(.disabled).active:hover {
  color: #fff !important;
}
.el-pagination.is-background .el-pager li:not(.disabled):hover {
  color: #cc4455;
}
</style>

